import React from 'react';
import Sidebar from './Sidebar';
import MobileMenu from './MobileMenu';
import LoadingSpinner from './LoadingSpinner';

const PageContainer = ({ 
  children, 
  loading, 
  loadingMessage,
  title,
  subtitle,
  onLogout 
}) => {
  return (
    <div className="page-root">
      <Sidebar onLogout={onLogout} />
      {/* Below 768px App.css hides .sidebar and reserves 70px of padding-top
          on .dashboard-container for the fixed mobile bar. Without this the
          space was reserved but nothing filled it, so every page rendered a
          70px blank strip AND had no navigation at all on mobile.
          AgentOpsContainer and AuthLayout already render this. */}
      <MobileMenu />
      <div className="dashboard-container">
        {!loading && (
          <div className="dashboard-header">
            <div>
              <h1 className="dashboard-title">{title}</h1>
              {subtitle && (
                <p className="dashboard-subtitle">{subtitle}</p>
              )}
            </div>
          </div>
        )}
        
        <div className="dashboard-content">
          {loading ? (
            <div className="loading-container">
              <LoadingSpinner message={loadingMessage} />
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

export default PageContainer;
